import React from "react";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import {
  AutocompleteInput,
  Datagrid,
  DateField,
  BooleanInput,
  Filter,
  List,
  ReferenceField,
  ReferenceInput,
  // SelectInput,
  TextField,
  TextInput,
} from "react-admin";
// Local
import { clearFilterButton } from "../../components";

export const DealerBidderIcon = LocalOfferIcon;

const DealerBidderFilter = props => (
  <Filter {...props}>
    <ReferenceInput source="dealerId" reference="dealers" alwaysOn>
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
    <TextInput source="name" alwaysOn />
    <BooleanInput source="deleted" label="Show deleted" defaultValue={true} />
    {clearFilterButton()}
  </Filter>
);

const DealerBidderList = props => (
  <List
    {...props}
    filters={<DealerBidderFilter />}
    // filterDefaultValues={{ field: "value" }}
    sort={{ field: "id", order: "DESC" }}
    bulkActionButtons={false}
    perPage={25}
  >
    <Datagrid optimized rowClick="edit">
      <TextField source="id" />
      <ReferenceField source="dealerId" reference="dealers">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="name" />
      <DateField source="createdAt" showTime />
      <DateField source="updatedAt" showTime />
      <DateField source="deletedAt" showTime />
    </Datagrid>
  </List>
);

export default DealerBidderList;
